'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroButtonGroup = require('./NitroButtonGroup');

var _NitroButtonGroup2 = _interopRequireDefault(_NitroButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroButtonGroup2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-button-group/index.js
// module id = 48
// module chunks = 4